if (window.collectionFilterSettings) {
  const settings = window.collectionFilterSettings

  var filterTitle = settings.title,
    txtFilter = settings.txtFilter,
    filterBlocks = settings.filterBlocks,
    shopUrl = settings.shopUrl,
    collectionUrl = settings.collectionUrl,
    filterCollapsingOrExpanding = settings.filterCollapsingOrExpanding,
    templateUnavailable = settings.templateUnavailable,
    plpFilterStock = settings.plpFilterStock;

  function getActiveSortedByValue() {
    var sortByURL = '';

    if (jQuery('#navToggle').is(":visible")) {
      // mobile view

      if (jQuery('#filterDropDown .sort-by .filter-button.selected').length > 0) {
        sortByURL = jQuery('#filterDropDown .sort-by .filter-button.selected').attr('data-value');

      }
    } else {
      // desktop
      if (jQuery('.toolbar .sort-by .filter-button.selected').length > 0) {
        sortByURL = jQuery('.toolbar .sort-by .filter-button.selected').attr('data-value');

      }
    }
    return sortByURL;
  }

  function renderFilters(filter, forcedNewFilters = null) {
    var collectionTags = [],
      currentFilters,
      filterHtml = '',
      $filterContainer = jQuery('#filterContainer'),
      sortByHtml = jQuery('#sorter').clone().removeAttr('id').html();
      dropdownArrow = `<span class="icon"><svg width="12" height="7" viewBox="0 0 12 7" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path d="M6.70618 6.29294C6.31563 6.68344 5.68246 6.6834 5.29196 6.29284L0.706818 1.70706C0.0769209 1.07707 0.523103 -3.39746e-07 1.41397 5.92083e-08L10.5855 -2.65759e-07C11.4765 -3.43647e-07 11.9226 1.07721 11.2926 1.70716L6.70618 6.29294Z" fill="currentColor"/>
</svg></span>`

    var url = shopUrl + collectionUrl;
    currentUrl = location.pathname;

    if (forcedNewFilters == null) {
      // allow for collections/all/ and collections/all
      currentFilters = currentUrl.replace(collectionUrl, '');
      collectionUrlNoSlash = collectionUrl.slice(0, -1),
        currentFilters = currentUrl.replace(collectionUrlNoSlash, '');

    } else {
      currentFilters = forcedNewFilters;
    }

    var filters = [],
      ajaxUrl = shopUrl.concat(collectionUrl) + currentFilters + '?view=ajax';

    if (ajaxUrl.split('?q=').length > 1) {
      ajaxUrl = ajaxUrl.replace('?q=', 'search?q=');
    }



    ajaxUrl += getActiveSortedByValue().replace('?sort_by', '&amp;sort_by');

    const arrFiltersToggle = [];

    jQuery('.filter .title').each(function () {
      if (jQuery(this).attr('aria-expanded') == 'true') {
        arrFiltersToggle.push(jQuery(this).data('filter'));
      }
    });

    filters = currentFilters.split('+');
    jQuery.ajax({
      type: 'GET',
      url: ajaxUrl,
      processData: false,
      contentType: false,
      success: function (data) {
        // get tags for this view:
        collectionTags = JSON.parse(jQuery(data).filter('.collection-tags').html());
        // get all other possible tags for the active filters:
        collectionAllTags = JSON.parse(jQuery(data).filter('.collection-all-tags').html());

        var filtersAreCollapsed = false;
        if (filterCollapsingOrExpanding == 'collapsing') {
          filtersAreCollapsed = true;
        }
        filterHtml += '<div class="filters">';
        filterHtml += '<div class="sorter">' + sortByHtml + '</div>';
        filterHtml += '<h2 class="filter-heading h6">' + txtFilter + '</h2>';
        jQuery.each(filterBlocks, function (index, block) {
          if (block == '') {
            return;
          }

          filter = block.toLowerCase() + '_';
          filterName = block;
          var isActive = filtersAreCollapsed && filterName != 'stock';
          filterHtml += '<div class="filter">';
          filterHtml += '<button type="button" aria-expanded="' + !isActive + '" data-filter="' + filterName + '" aria-labelledby="' + filterName + '" class="title';
          if (filtersAreCollapsed && filterName != 'stock') {
            filterHtml += ' active';
          }

          if (filterTranslateBlocks[filterName]) {
            filterName = filterTranslateBlocks[filterName];
          }

          //Custom for DE
          filterHtml += '">' + filterName.replace(/--/g, '*').replace(/-/g, ' ').replace('*', '-') + dropdownArrow + '</button>' ;
          filterHtml += '<div class="filter-list"';
          if (filtersAreCollapsed && filterName != 'stock') {
            filterHtml += ' style="display:none;"';
          }
          filterHtml += '>';

          var theseTagsToAdd = [];

          jQuery.each(collectionTags, function (index, tag) {
            if (tag.indexOf(filter) != -1) {
              theseTagsToAdd.push(tag);
            }
          });

          theseTagsToAdd = [...new Set(theseTagsToAdd)];
          theseTagsToAdd.sort();

          if (filterSortedList[block].length > 0) {
            let block_FilterSortedList = filterSortedList[block];

            for (var i = 0; i < block_FilterSortedList.length; i++) {
              block_FilterSortedList[i] = block + '_' + block_FilterSortedList[i].trim();
            }

            theseTagsToAdd = block_FilterSortedList.concat(theseTagsToAdd);
            theseTagsToAdd = [...new Set(theseTagsToAdd)];
          }

          jQuery.each(theseTagsToAdd, function (index, tag) {
            let filterTag = tag.replace(filter, '');
            if (filterTranslateList[filterTag]) {
              filterTag = filterTranslateList[filterTag];
            }
            filterHtml += '<button tabindex="0" role="button" type="button" class="filter-button filter-tag" data-value="' + tag.replace(/\s/g, "-") + '">' + filterTag + '</button>';
          });


          filterHtml += '</div>';
          filterHtml += '</div>';
        });
        filterHtml += '</div>';
        $filterContainer.empty().html(filterHtml);
        jQuery('.filters-current').empty();
        jQuery.each(filters, function (index, filter) {
          // remove / at start of first tag:
          if (filter.charAt(0) == '/') {
            filter = filter.substring(1);
          }

          var filter_button = jQuery('.filter-button[data-value="' + filter.replace(/\s/g, "-") + '"]');
          filter_button.addClass('selected').clone().addClass('current').appendTo('.filters-current');
          filter_button.parents('.filter').eq(0).addClass('active').find('.title').removeClass('active').attr('aria-expanded', true).next().show();
        });
        // hide any empty filter options:
        jQuery('#filterContainer .filter').each(function () {
          if (jQuery(this).find('.filter-tag').length < 1) {
            jQuery(this).hide();
          } else {
            jQuery(this).show();
          }
        });

        // check session and expand filters
        if (sessionStorage.getItem("visibleFilters") !== null) {
          //  setTimeout(function(){
          var openFilters = sessionStorage.getItem("visibleFilters").split("|||");
          for (var i = 0; i < openFilters.length; i++) {
            jQuery('#filterContainer .filter:visible h6[data-filter=' + openFilters[i] + ']').removeClass('active').next().show();
          }
          // }, 250);
        }
        if (arrFiltersToggle.length > 0) {
          jQuery.each(arrFiltersToggle, function (index, filter) {
            jQuery('.filter .title[data-filter="' + filter + '"]').removeClass('active').attr('aria-expanded', true).next().show();
          });
        }

      }
    });
  }
  function renderProducts(filter, isAHistoryUpdate = false) {

    var url = shopUrl + collectionUrl;
    currentUrl = location.pathname;

    var currentFilters = currentUrl.replace(collectionUrl, '');
    filters = [], filtersSort = [],
      sort_by = '', ajaxUrl = url,
      $products = jQuery('#product-grid');
    $pagination = jQuery('.collection-pagination .pagination');


    if (filter == null) {
      filter = '';
    }

    if (filter.split('?page=').length > 1) {
      url = shopUrl + filter;
    } else {
      //Check filter is sort_by
      if (filter.split('?').length > 1) {
        sort_by = filter;
      }

      //Check has filters
      if (currentUrl.length > collectionUrl.length) {
        if (currentFilters.length > 0) {
          filters = currentFilters.split('+');
          if (filters.indexOf(filter) > -1) {
            filters.splice(filters.indexOf(filter), 1);
          } else {
            if (filter.split('?').length <= 1) {
              filters.push(filter);
            }
          }
        }
      } else {
        if (filter.split('?').length <= 1) {
          filters.push(filter);
        }
      }

      //Sort the filters
      var hasStockFilter = false;
      if (filterBlocks.length > 0) {
        jQuery.each(filterBlocks, function (index, block) {
          blockFilter = block.toLowerCase() + '_';
          jQuery.each(filters, function (index, thisFilter) {
            if (thisFilter.indexOf('stock_') != -1) {
              hasStockFilter = true;
            }
            if (thisFilter.indexOf(blockFilter) != -1) {
              if (filter.indexOf(blockFilter) != -1) {
                if (filter == thisFilter) {
                  if (!filtersSort.includes(thisFilter)) {
                    filtersSort.push(thisFilter);
                  }
                }
              } else {
                if (!filtersSort.includes(thisFilter)) {
                  filtersSort.push(thisFilter);
                }
              }
            }
          });
        });
      }
      if (!hasStockFilter) {
        if (!baseStockFilter.includes("https")) {
          filtersSort.push(baseStockFilter);
          jQuery('.filter-button[data-value="' + baseStockFilter.replace(/\s/g, "-") + '"]').addClass('selected').parents('.filter').eq(0).addClass('active');
        }
      }

      filtersSort = filtersSort.join('+');
      const characters = filtersSort.substring(filtersSort.length - 1, filtersSort.length);
      if (characters === '+') {
        filtersSort = filtersSort.slice(0, -1);
      }
      url += filtersSort;

      //Clear All
      if (filter == 'clear-all') {
        url = shopUrl + collectionUrl;
      }

      if (sort_by != '') {
        if (location.search.length) {
          if (location.search.split('?page=').length > 1) {
            sort_by = sort_by.replace('?sort_by=', '&sort_by=');
            var ls_url = location.search;
            if (ls_url.split('&sort_by=').length > 1) {
              ls_url = ls_url.substring(0, ls_url.indexOf('&sort_by='));
            }
            url += ls_url + sort_by;
          }
        } else {
          url += sort_by;
        }
      } else {
        if (filter == '') {
          var ls_url = location.search;
          if (ls_url.length) {
            if (ls_url.split('sort_by=').length > 1) {
              ls_url = ls_url.substring(ls_url.indexOf('sort_by='), ls_url.length);
              url += '?' + ls_url;
            } else {
              url += ls_url;
            }
          }
        }
      }
    }

    ajaxUrl = url;

    if (url.split('?').length > 1) {
      if (templateUnavailable) {
        ajaxUrl += '&view=unavailable-ajax';
      } else {
        ajaxUrl += '&view=ajax';
      }

      if (ajaxUrl.split('?q=').length > 1) {
        ajaxUrl = ajaxUrl.replace('?q=', 'search?q=');
      }
    } else {
      if (templateUnavailable) {
        ajaxUrl += '?view=unavailable-ajax';
      } else {
        ajaxUrl += '?view=ajax';
      }
    }

    if (!isAHistoryUpdate) {
      var historyURL = url;
      if (url.indexOf('sort_by') == -1) {
        historyURL += getActiveSortedByValue();
      } else {
        var s_path = '';
        if (location.search.length) {
          var location_search = location.search.split('?');

          jQuery.each(location_search, function (index, ls_url) {
            if (ls_url.indexOf('sort_by=') == -1 && ls_url != '') {
              s_path += '?' + ls_url;
            }
          });
          s_path = s_path.replace('??', '?');
        }

        historyURL = url.split('?')[0] + getActiveSortedByValue() + s_path;
      }
      let historyURL_noSorted = historyURL.replace(getActiveSortedByValue(), '');

      window.history.pushState({ path: historyURL_noSorted }, '', historyURL_noSorted);
    }


    ajaxUrl += getActiveSortedByValue().replace('?sort_by', '&amp;sort_by');


    jQuery.ajax({
      type: 'GET',
      url: ajaxUrl,
      processData: false,
      contentType: false,
      success: function (data) {
        $products_html = jQuery(data).find('.product-grid').html();
        if (templateUnavailable) {
          $pagination_html = jQuery(data).find('.collection-pagination').html().replace(/&amp;view=unavailable-ajax/g, '');
        } else {
          $pagination_html = jQuery(data).find('.collection-pagination').html().replace(/&amp;view=ajax/g, '');
        }
        $pagination.empty().html($pagination_html);
        $products.empty().html($products_html).removeClass('loading');
        productCompareHandle();
        colourSwatchesHover();

      }
    });
  }
  jQuery(document).ready(function () {
    if (location.search.length == 0 && plpFilterStock && plpFilterStock.length > 0) {
      window.location = plpFilterStock
    }
    renderFilters();
    renderProducts();

    jQuery('#sorter .label .value').html(jQuery('#sorter .sort-by .filter-button.selected').text());
    jQuery('#sorter .label').click(function (e) {
      jQuery(this).toggleClass('active').next().slideToggle(300);
      e.preventDefault();
    });

    jQuery(document).on('click', function (e) {
      if (jQuery(e.target).closest('#sorter .label').length === 0) {
          jQuery('#sorter .label').removeClass('active').next().hide("slide", {direction: "up"}, 300);
      }
    });


    jQuery(window).on("popstate", function (e) {
      if (e.originalEvent.state !== null) {
        renderFilters();
        renderProducts(null, true);

      }
    });
  });

  jQuery(document).on('click', '.filter-button', function (e) {

    var value = jQuery(this).data('value'),
      filter_tag = value.split('_')[0];

    if (value == 'clear-all') {
      jQuery('.filters').find('.filter-button').removeClass('selected');
      jQuery('.filters-current').empty();
    }

    if (jQuery(this).parents('.sort-by').length > 0) {
      //Sort by Click
      jQuery(this).parent().slideToggle(300);
      if (!jQuery(this).hasClass('selected')) {
        jQuery('.filter-button[data-value="' + value + '"]').addClass('selected').parent().prev().find('.value').html(jQuery(this).text());
        jQuery('.filter-button[data-value="' + value + '"]').parent().find('.filter-button').not(jQuery(this)).removeClass('selected');
      } else {
        return;
      }
    } else {
      //Filter Click


      if (jQuery(this).hasClass('current')) {
        jQuery('.filters').find('[data-value*=' + filter_tag + ']').removeClass('selected');
      }
      if (jQuery(this).hasClass('filter-tag')) {
        jQuery('.filters-current').find('[data-value*=' + filter_tag + ']').remove();
      }
      if (jQuery(this).hasClass('selected')) {
        jQuery(this).removeClass('selected').parents('.filter').eq(0).removeClass('active');
      } else {
        jQuery(this).addClass('selected').parents('.filter').eq(0).addClass('active').find('.filter-button').not(jQuery(this)).removeClass('selected');
        if (jQuery(this).hasClass('filter-tag')) {
          //     jQuery(this).clone().addClass('current').appendTo('.filters-current');
          //     theseCurrentFilters += jQuery(this).attr('data-value');
        }
      }

      var theseCurrentFilters = '';
      jQuery('#filterContainer .filter-tag.selected').each(function () {
        if (theseCurrentFilters != '') {
          theseCurrentFilters += '+';
        }
        theseCurrentFilters += jQuery(this).attr("data-value");
      });

      renderFilters(null, theseCurrentFilters);

    }
    jQuery('#product-grid').addClass('loading');
    renderProducts(value);
    jQuery('html, body').animate({
      scrollTop: jQuery('.collection-products').offset().top,
    });
    e.preventDefault();
  });
  jQuery(document).on('click', '.collection-pagination a', function (e) {
    var value = jQuery(this).attr('href');
    jQuery('#product-grid').addClass('loading');
    renderProducts(value);

    setTimeout(function() {
      $('html,body').animate({
        scrollTop: jQuery('.collection-title').offset().top
      }, 250);
    }, 1500);

    e.preventDefault();
  });
  jQuery(document).on('click', '.filter .title', function (e) {
    if (jQuery(this).hasClass('active')) {
      jQuery(this).attr('aria-expanded', true).removeClass('active').next().slideDown(300);
    } else {
      jQuery(this).attr('aria-expanded', false).addClass('active').next().slideUp(300);
    }
    // jQuery(this).attr('aria-expanded', jQuery(this).hasClass('active'));
    e.preventDefault();


    // store expanded filters
    var newVisibleFilters = '';
    jQuery("#filterContainer .filter:visible h6:not(.active)").each(function () {
      newVisibleFilters += jQuery(this).attr("data-filter") + "|||";
    });
    sessionStorage.setItem("visibleFilters", newVisibleFilters)


  });

  jQuery('#view-grid button').click(function (e) {
    if (jQuery(this).hasClass('layout-2-grid')) {
      //localStorage.setItem('viewGrid', 2);
      jQuery('#view-grid button.layout-2-grid').addClass('active');
      jQuery('#view-grid button.layout-3-grid').removeClass('active');
      jQuery('#product-grid').removeClass('layout-3-grid').addClass('layout-2-grid');
    }
    if (jQuery(this).hasClass('layout-3-grid')) {
      //localStorage.setItem('viewGrid', 3);
      jQuery('#view-grid button.layout-3-grid').addClass('active');
      jQuery('#view-grid button.layout-2-grid').removeClass('active');
      jQuery('#product-grid').removeClass('layout-2-grid').addClass('layout-3-grid');
    }
    e.preventDefault();
  });
}
